import {
  storeGet,
  STORE_KEY_ACCOUNT,
  STORE_KEY_ID_LIST,
  STORE_KEY_LIST
} from 'mailup-react-helpers'
import { bePubCustomListLandingPages } from 'Api/bePubCustomApi'
import { getMocAuthTokenApi } from 'Api/mochAuthApi'
import {
  INPUT_VALUE_CUSTOM_URL,
  INPUT_VALUE_LANDING_PAGE
} from '../state/input'
import { getShortUrlApi } from 'Api/urlShortnerApi'

export const ORDERBY_MODIFY_DATE = 'ModifyDate'
export const ORDERBY_NAME = 'Name'

export const getLandingPages = async ({
  searchTerm = '',
  orderBy = ORDERBY_NAME
}) => {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const filterParams = {
    searchText: searchTerm.length > 0 ? searchTerm.trim() : '',
    orderBy,
    type: 1,
    pageSize: 0
  }

  const res = await bePubCustomListLandingPages(idList, filterParams)

  if (res) {
    const items = res.Items.map(item => ({
      value: item.Id,
      label: `${item.Id} - ${item.Name}`
    }))

    return { items, totalItems: items.length }
  }
  return { items: [], totalItems: 0 }
}

export const getMessage = async (type, url, idLp) => {
  if (type === INPUT_VALUE_CUSTOM_URL) {
    return url
  } else if (type === INPUT_VALUE_LANDING_PAGE) {
    const idList = storeGet(STORE_KEY_ID_LIST)
    const { Guid } = storeGet(STORE_KEY_LIST)
    const { Domain } = storeGet(STORE_KEY_ACCOUNT)

    return `https://${Domain}/frontend/LandingPage.aspx?idList=${idList}&idLP=${idLp}&guid=${Guid}`
  }
}

export const getMocAuthTokenAction = async () => {
  const resp = await getMocAuthTokenApi()
  return resp
}

export async function getShortUrl(url, trackOptin, token) {
  const { Id: idConsole } = storeGet(STORE_KEY_ACCOUNT)
  const resp = await getShortUrlApi(url, trackOptin, idConsole, token)
  return resp
}
